/**
 * The deferred-payment question's outcomes — the only question this build
 * answers, and the product the system was built for. `REVIEW` exists in the
 * type space because a later rule will need it, but nothing produces it today.
 *
 * Outcomes belong to a question. A second question (CLAUDE.md, *Questions*)
 * defines its own when it arrives — reusing these if a payment term is what it
 * answers with, or its own words if not. A shared, generic vocabulary
 * (`RESTRICT` for every question) was tried on 2026-09-01 and set aside the
 * same day: it renamed the one product that exists for the benefit of ones that
 * do not, and `PREPAYMENT` says what the gate actually answers.
 */
export const Decision = {
    /** Deferred payment granted. */
    ALLOW: "ALLOW",
    /** We still sell — the customer pays upfront. Never a refusal (constraint 1). */
    PREPAYMENT: "PREPAYMENT",
    /** Awaiting a human. Reserved; never returned by this version. */
    REVIEW: "REVIEW",
};
/**
 * The boolean an apiClient branches on. **Only `ALLOW` grants deferral** — an
 * unhandled decision must fall to prepayment, which is what makes adding
 * `REVIEW` later a non-breaking change (constraint 2).
 */
export function allowsDeferred(decision) {
    return decision === Decision.ALLOW;
}
//# sourceMappingURL=decision.js.map